import * as React from 'react';

export default function LoginTermsOfService() {
  return <></>;
}
